import { Component, OnInit, RendererFactory2, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRouteSnapshot, NavigationEnd, NavigationError } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AccountService } from '@cupoui/core/auth/account.service';
import { SettingsService } from '@cupoui/core/services/settings.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
    selector: 'jhi-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;
  isProduction = true;

  private renderer: Renderer2;
  private readonly _mobileQueryListener: () => void;

  constructor(
    private accountService: AccountService,
    private settingService: SettingsService,
    private titleService: Title,
    private router: Router,
    private translateService: TranslateService,
    rootRenderer: RendererFactory2,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.renderer = rootRenderer.createRenderer(document.querySelector('html'), null);
    this.mobileQuery = media.matchMedia('(max-width: 960px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();

    // Outcommented to make work in MS Edge!
    // this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.isProduction = this.settingService.isProduction();

    // Try to log in automatically
    this.accountService.identity().subscribe();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateTitle();
      }
      if (event instanceof NavigationError && event.error.status === 404) {
        this.router.navigate(['/404']);
      }
    });

    this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.updateTitle();

      this.renderer.setAttribute(document.querySelector('html'), 'lang', langChangeEvent.lang);
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  isAdmin(): boolean {
    return this.accountService.getLogin() === 'admin';
  }

  isHomeActive(): boolean {
    return this.router.url.includes('/home');
  }

  isMobilityBusinessArea(): boolean {
    // we need to widen the 'check' to more than just 'case-mobility'
    // as the footer seems to also be part of other parts of the ui than just cases
    return this.router.url.includes('mobility');
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
    let title: string = routeSnapshot.data && routeSnapshot.data['pageTitle'] ? routeSnapshot.data['pageTitle'] : '';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private updateTitle(): void {
    let pageTitle = this.getPageTitle(this.router.routerState.snapshot.root);
    if (!pageTitle) {
      pageTitle = 'global.title';
    }
    this.translateService.get(pageTitle).subscribe(title => this.titleService.setTitle(title));
  }
}
